import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
const KEY = "virality_theme";

export function ThemeProvider({ children }) {
  // Always light — the design is orange/white. Dark mode removed.
  const [theme] = useState("light");

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("dark");
    localStorage.setItem(KEY, "light");
  }, []);

  // toggle is a no-op — kept so existing components that call toggle() don't crash
  const toggle = () => {};

  return <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
